export const placeHolder = {
    page: 'batchPicture',
    subtitle: '使用一个模版，支持营销图批量生产',
    image: 'https://feed-image.baidu.com/0/pic/533030698_1549823988_-56109884.png'
};

export const btbIndustry = [
    '机械设备',
    '化工及能源',
    '农林牧渔',
    '电子电工'
];

export const normalIndustry = [
    '全部行业',
    '房产家居',
    '旅游服务',
    '交通出行',
    '整形美容',
    '教育培训',
    '金融服务',
    '商品交易',
    '医疗服务',
    '生活服务',
    '文娱传媒',
    '商务服务',
    '游戏',
    '软件',
    '网络服务',
    '通信',
    '直营电商',
    '食品饮料',
    '保健品/药品'
];

export const openIndustryByHot = [
    '全部行业',
    '教育培训',
    '文娱传媒',
    '金融服务',
    '生活服务',
    '房产家居',
    '整形美容',
    '商务服务',
    '旅游服务',
    '商品交易',
    '游戏',
    '软件',
    '交通出行',
    '网络服务',
    '机械设备',
    '医疗服务',
    '农林牧渔',
    '通信',
    '化工及能源',
    '电子电工',
    '直营电商',
    '食品饮料',
    '保健品/药品'
];

export const btbIndustryTradeId = [
    2005,
    2029,
    2027,
    2024
];

export const industryTradeIdMap = {
    2001: '3',
    2002: '4',
    2005: '14',
    2006: '7',
    2007: '8',
    2008: '19',
    2010: '13',
    2015: '10',
    2017: '15',
    2018: '16',
    2019: '5',
    2020: '17',
    2022: '9',
    2023: '11',
    2024: '28',
    2025: '29',
    2026: '30',
    2027: '31',
    2029: '20'
};

export const openIndustry = [
    ...normalIndustry,
    ...btbIndustry
];

export const ratioMaxLengthMap = {
    'btb': {
        businessPointB2B: 20,
        sellingPointFirst: 5,
        sellingPointSecond: 5,
        sellingPointThird: 5,
        manufacturerName: 12
    },
    '1:1': {
        mainText: 20,
        descText: 20,
        buttonText: 4,
        otherText: 10
    },
    'base': {
        mainText: 20,
        descText: 20,
        buttonText: 6,
        otherText: 14
    }
};

export const designSizeOptions =  [
    {
        value: '1:1',
        label: '1:1',
        children: [
            {
                value: '600*600',
                label: '600*600'
            }
        ]
    }, {
        value: '16:9',
        label: '16:9',
        children: [
            {
                value: '1140*640',
                label: '1140*640'
            }, {
                value: '1280*720',
                label: '1280*720'
            }, {
                value: '1600*900',
                label: '1600*900'
            }, {
                value: '1920*1080',
                label: '1920*1080'
            }, {
                value: '960*540',
                label: '960*540'
            }
        ]
    }, {
        value: '3:4',
        label: '3:4',
        children: [
            {
                value: '750*1000',
                label: '750*1000'
            }
        ]
    }, {
        value: '3:2',
        label: '3:2',
        children: [
            {
                value: '1200*800',
                label: '1200*800'
            }
        ]
    }, {
        value: '3:1',
        label: '3:1',
        children: [
            {
                value: '1200*400',
                label: '1200*400'
            }
        ]
    }, {
        value: '9:16',
        label: '9:16',
        children: [
            {
                value: '1080*1920',
                label: '1080*1920'
            },
            {
                value: '640*1140',
                label: '640*1140'
            }
        ]
    }
];

export const intelSizeOptions = [
    {
        value: '1:1',
        label: '1:1',
        children: [
            {
                value: '600*600',
                label: '600*600'
            }
        ]
    }, {
        value: '2:1',
        label: '2:1',
        children: [
            {
                value: '800*400',
                label: '800*400'
            }, {
                value: '600*300',
                label: '600*300'
            }
        ]
    }, {
        value: '3:2',
        label: '3:2',
        children: [
            {
                value: '960*640',
                label: '960*640'
            },
            {
                value: '1200*800',
                label: '1200*800'
            }, {
                value: '900*600',
                label: '900*600'
            }
        ]
    }, {
        value: '2:3',
        label: '2:3',
        children: [
            {
                value: '1080*1620',
                label: '1080*1620'
            }, {
                value: '1242*1863',
                label: '1242*1863'
            }
        ]
    }, {
        value: '3:1',
        label: '3:1',
        children: [
            {
                value: '1200*400',
                label: '1200*400'
            }, {
                value: '1152*384',
                label: '1152*384'
            }, {
                value: '900*300',
                label: '900*300'
            }
        ]
    }, {
        value: '4:3',
        label: '4:3',
        children: [
            {
                value: '800*600',
                label: '800*600'
            }
        ]
    }, {
        value: '9:16',
        label: '9:16',
        children: [
            {
                value: '1080*1920',
                label: '1080*1920'
            }, {
                value: '1242*2208',
                label: '1242*2208'
            }, {
                value: '720*1280',
                label: '720*1280'
            }
        ]
    }, {
        value: '16:9',
        label: '16:9',
        children: [
            {
                value: '1140*640',
                label: '1140*640'
            }, {
                value: '1280*720',
                label: '1280*720'
            }, {
                value: '1600*900',
                label: '1600*900'
            }, {
                value: '1920*1080',
                label: '1920*1080'
            }, {
                value: '960*540',
                label: '960*540'
            }
        ]
    }, {
        value: '3:4',
        label: '3:4',
        children: [
            {
                value: '750*1000',
                label: '750*1000'
            }
        ]
    }
];

export const temParams = {
    pageNo: 1,
    pageSize: 10,
    tags: [],
    sortField: 'max_time',
    sortOrder: 'desc',
    type: 'PIC',
    productLine: 'FEED',
    platform: 'QingDuo'
};

export const editorJson = '{}';